import React, { useCallback } from 'react';

import { withStyles, WithStyles } from '@material-ui/core';

import { TypographyI18n } from 'components/v2';
import { generateMessageTemplateKey, getMessageTemplateKey, useMessageTemplate } from 'hooks';

import { useLumaBotContext } from '../../LumaBot.context';
import { EMessageType } from '../../WIP/ui-model/types';

import AppointmentsList from './components/AppointmentsList';
import Button from './components/Button';
import styles from './Rescheduler.styles';
import useUpcomingAppointments from './useUpcomingAppointments';

const currentDate = new Date();

export interface IRescheduler extends WithStyles<typeof styles> {}

const Rescheduler = ({ classes }: IRescheduler) => {
  const { pushAnswer: onSubmit } = useLumaBotContext();
  const { refetch } = useUpcomingAppointments(currentDate);
  const doneButtonTemplateKey = generateMessageTemplateKey('patientLumaBotManageAppointmentDone');
  const doneButtonTemplateText = useMessageTemplate(getMessageTemplateKey(doneButtonTemplateKey));

  const handleLeave = useCallback(() => {
    onSubmit({
      text: doneButtonTemplateText,
      type: EMessageType.Outbound,
      metadata: { includeRevert: false },
    });
  }, [onSubmit, doneButtonTemplateText]);

  return (
    <div className={classes.rescheduler}>
      <TypographyI18n variant="h3W600F17" align="center">
        {generateMessageTemplateKey('patientLumaBotManageAppointmentHeader')}
      </TypographyI18n>
      <AppointmentsList currentDate={currentDate} />
      <div className={classes.buttonsContainer}>
        <Button data-lh-id="button-leave" onClick={() => refetch()}>
          <TypographyI18n variant="bW600F14" color="inherit">
            {generateMessageTemplateKey('patientLumaBotManageAppointmentRefreshList')}
          </TypographyI18n>
        </Button>
        <Button data-lh-id="button-leave" onClick={handleLeave}>
          <TypographyI18n variant="bW600F14" color="inherit">
            {doneButtonTemplateKey}
          </TypographyI18n>
        </Button>
      </div>
    </div>
  );
};

export default withStyles(styles, { name: 'Rescheduler' })(Rescheduler);
